module.exports = __webpack_public_path__ + "static/media/totals.dc40b4ed.png";